import * as React from 'react'
import { LifeInsuranceResults, LifeInsuranceResultsProps } from '../Results'
import { SimplifiedResults, SimplifiedResultsProps } from '../SimplifiedResults'

type UnifiedResultsProps = SimplifiedResultsProps & LifeInsuranceResultsProps & { showOriginalLayout: boolean }
export const UnifiedResults: React.FC<UnifiedResultsProps> = (props) => {
  if (props.showOriginalLayout) {
    return <LifeInsuranceResults {...props} />
  }

  return <SimplifiedResults {...props} offers={props.allLifeInsuranceOffers} />
}
